import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { EventTeam } from '../../types';
import './TeamQRCodes.css';

interface TeamQRCodesProps {
  teams: EventTeam[];
  eventId: string;
  baseUrl?: string;
  onClose: () => void;
  onGenerateCodes: () => void;
}

const TeamQRCodes: React.FC<TeamQRCodesProps> = ({
  teams,
  eventId,
  baseUrl,
  onClose,
  onGenerateCodes
}) => {
  const [printMode, setPrintMode] = useState(false);
  
  // Determine base URL for QR codes
  const getBaseUrl = () => {
    if (baseUrl) return baseUrl;
    // Use current origin
    return window.location.origin;
  };
  
  // Get join URL for a team
  const getJoinUrl = (joinCode: string) => {
    return `${getBaseUrl()}/team/${joinCode}`;
  };
  
  // Check if any team needs a code
  const teamsWithoutCode = teams.filter(t => !t.joinCode);
  
  // Handle print
  const handlePrint = () => {
    setPrintMode(true);
    setTimeout(() => {
      window.print();
      setPrintMode(false);
    }, 100);
  };
  
  return (
    <div className={`team-qr-modal ${printMode ? 'print-mode' : ''}`}>
      <div className="team-qr-content">
        <button onClick={onClose} className="team-qr-close-btn" title="Sluiten">
          ✕
        </button>
        
        <div className="team-qr-header">
          <h2>Team QR Codes</h2>
          <div className="team-qr-actions">
            {teamsWithoutCode.length > 0 && (
              <button onClick={onGenerateCodes} className="generate-btn">
                Genereer Codes ({teamsWithoutCode.length})
              </button>
            )}
            <button onClick={handlePrint} className="print-btn">
              🖨️ Print
            </button>
          </div>
        </div>
        
        <p className="team-qr-intro">
          Teams kunnen deze QR code scannen of de code invoeren op <strong>{getBaseUrl()}/join</strong>
        </p>
        
        <div className="team-qr-grid">
          {teams.map(team => (
            <div key={team.id} className="team-qr-card">
              <div className="team-qr-name">{team.name}</div>
              
              {team.joinCode ? (
                <>
                  <div className="team-qr-code-wrapper">
                    <QRCodeSVG
                      value={getJoinUrl(team.joinCode)}
                      size={160}
                      level="M"
                      includeMargin={true}
                      bgColor="#ffffff"
                      fgColor="#1a1a2e"
                    />
                  </div>
                  <div className="team-qr-code-text">{team.joinCode}</div>
                  <div className="team-qr-url">{getJoinUrl(team.joinCode)}</div>
                </>
              ) : (
                <div className="team-qr-no-code">
                  <span>Geen code</span>
                  <small>Klik "Genereer Codes"</small>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {teams.length === 0 && (
          <div className="team-qr-empty">
            <p>Geen teams gevonden. Voeg eerst teams toe aan het evenement.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamQRCodes;
